import { BCMSRecord, useGlobalController, useParams, Workflow } from "@bcm-dev/bcms-vite";
import ViewBillPage from "compid/pages/ViewBillPage";
import { Bill, Payment } from "model";
import React from "react";

const steps = {
    "/viewBill" : <ViewBillPage/>
};

/**
 * @function ViewBillWorkflow
 * @returns {React.Component}
 * @description The main component for the "View Bill" workflow
 */
export default function ViewBillWorkflow(props) {
    // Initalize a global controller instance
    const controller = useGlobalController();
    // Grab the billerID from the parameters
    const { billID } = useParams();
    // Get the default value for the workflow
    const value = getDefault(controller, billID);
    return <Workflow value={ value } steps={ Object.values(steps) } />
}

/**
 * @function getWorkflowSteps
 * @returns {OBJECT}
 * @description Hook to get the steps of the reminder workflow
 */
export const getWorkflowSteps = () => steps;

/**
 * @function getDefault
 * @param {BCMSGlobalController} controller - Global controller instance
 * @param {STRING} billID - The bill id passed through the parameter
 * @returns {OBJECT}
 * @description Function to create the default value of the "View Bill" workflow.
 */
export const getDefault = (controller, billID) => {
    BCMSRecord.globalControllerFor([ Bill, Payment ], controller);
    const bill = billID === undefined ? Bill.firstInstanceOf() : Bill.initByID(billID);

    return {
        bill: bill
    };
};